'use strict'

import axios from 'axios'

class HttpClient {
  headers = {
    'authorization': 'Bearer ' + window.$cookies.get('token'),
    'Content-Type': 'application/json'
  }
  sendGet (url, headers = {}) {
    return new Promise(function (resolve, reject) {
      axios({
        method: 'get',
        url: process.env.VUE_APP_LOGISTY_API_HOST_NAME + url,
        headers: headers
      })
        .then(function (result) {
          resolve(result.data)
        })
        .catch(function (error) {
          if (typeof error.response !== 'undefined') {
            resolve(error.response.data)
          } else {
            reject(error)
          }
        })
    })
  }

  sendPost (url, headers = {}, content = {}) {
    return new Promise(function (resolve, reject) {
      axios({
        method: 'post',
        url: process.env.VUE_APP_LOGISTY_API_HOST_NAME + url,
        data: content,
        headers: headers
      })
        .then(function (result) {
          resolve(result.data)
        })
        .catch(function (error) {
          if (typeof error.response !== 'undefined') {
            resolve(error.response.data)
          } else {
            reject(error)
          }
        })
    })
  }

  sendPut (url, headers = {}, content = {}) {
    return new Promise(function (resolve, reject) {
      axios({
        method: 'put',
        url: process.env.VUE_APP_LOGISTY_API_HOST_NAME + url,
        data: content,
        headers: headers
      })
        .then(function (result) {
          resolve(result.data)
        })
        .catch(function (error) {
          if (typeof error.response !== 'undefined') {
            resolve(error.response.data)
          } else {
            reject(error)
          }
        })
    })
  }

  sendDelete (url, headers = {}, content = {}) {
    return new Promise(function (resolve, reject) {
      axios({
        method: 'delete',
        url: process.env.VUE_APP_LOGISTY_API_HOST_NAME + url,
        data: content,
        headers: headers
      })
        .then(function (result) {
          resolve(result.data)
        })
        .catch(function (error) {
          if (typeof error.response !== 'undefined') {
            resolve(error.response.data)
          } else {
            reject(error)
          }
        })
    })
  }

  sendGetPdf (url, headers = {}) {
    return new Promise(function (resolve, reject) {
      axios({
        method: 'get',
        url: process.env.VUE_APP_LOGISTY_API_HOST_NAME + url,
        headers: headers,
        responseType: 'blob'
      })
        .then(function (result) {
          resolve(result.data)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }

  sendGetFile (url, headers = {}) {
    return new Promise(function (resolve, reject) {
      axios({
        method: 'get',
        url: process.env.VUE_APP_LOGISTY_API_HOST_NAME + url,
        headers: headers,
        responseType: 'blob'
      })
        .then(function (result) {
          resolve(result.data)
        })
        .catch(function (error) {
          reject(error)
        })
    })
  }
}

export default HttpClient
